module.exports = __webpack_public_path__ + "static/media/icn_sort_numeric_active.0e6d2408.svg";